import ContentLanguageSelect from 'components/ContentLanguageSelect';
import { Button, Icon, Image, Tooltip } from 'imaginarity-react-ui';
import * as React from 'react';
import { getTranslatedUserName } from 'services/Helpers/TranslationHelpers';
import { WikiSC as T } from './WikiSC';

export type WikiColumnReviewFooterProps = {
    isActive: boolean;
    reviewMode: boolean | undefined;
    isVerified: boolean;
    reviewChangedDummyAvatarUrl: string;
    reviewChangedUser: any;
    reviewChangedDate: string;
    t: (key: string, opts?: any) => string;
    availableLngs: string[];
    openPartReview: () => void;
    closePartReview: () => void;
    saveReview: () => void;
    reviewIsSaveable: boolean;
};

const WikiColumnReviewFooter = (p: WikiColumnReviewFooterProps) => {
    const {
        isActive, reviewMode, isVerified, reviewChangedDummyAvatarUrl, reviewChangedUser,
        reviewChangedDate, t, availableLngs, openPartReview, closePartReview, saveReview,
        reviewIsSaveable,
    } = p;

    return (
        <T.RevisionFooter className='revFoot'>
            {reviewMode && !isActive ?
                <>
                    {isVerified &&
                        <div style={{ float: "left", marginLeft: 0, height: 36, width: 36, cursor: "pointer", padding: "5px 0px 0 5px" }}>
                            <Image src={reviewChangedDummyAvatarUrl} rounded width="30px" squared shadowed />
                        </div>
                    }
                    {isVerified ?
                        <div style={{ display: "grid", gridTemplateColumns: "max-content max-content", columnGap: 5, float: "left", marginLeft: 10, lineHeight: "15px", marginTop: 5, fontSize: "13px" }}>
                            <div style={{ fontWeight: "bolder" }}>{t("reviewed by")}:</div>
                            <div>{getTranslatedUserName(reviewChangedUser)} <span style={{ marginLeft: 10 }}>({reviewChangedUser?.email})</span></div>
                            <div style={{ fontWeight: "bolder" }}>{t("review Date")}:</div>
                            <div>{reviewChangedDate}</div>
                        </div>
                        :
                        <div style={{ float: "left", marginLeft: 10, lineHeight: "40px", fontSize: "13px" }}>
                            <Tooltip tooltipText={t("this part has not yet been verified")} noMargin position='top'>
                                <div>
                                    <Icon name="eye close" style={{ float: "left", marginRight: 5 }} marginTop={6} />
                                    {t("not yet verified")}
                                </div>
                            </Tooltip>
                        </div>
                    }
                    <Button
                        kind="halfTransparentButton"
                        floated='right'
                        icon='edit'
                        content={t("review")}
                        tooltip={{ tooltipText: t("review this part"), background: "@accentLightBlue", fontColor: "@mainBackground", position: "top" }}
                        onClick={openPartReview}
                    />
                    <div style={{ width: 150, float: "right" }}>
                        <ContentLanguageSelect languages={availableLngs} />
                    </div>
                </>
                :
                <Button
                    kind="primary"
                    floated='right'
                    icon='send'
                    content={t("send")}
                    disabled={!reviewIsSaveable}
                    tooltip={{ tooltipText: t("send the review for verification"), background: "@accentRed", fontColor: "@mainBackground", position: "top" }}
                    onClick={saveReview}
                />
            }
            {reviewMode && isActive && (
                <Button
                    kind="secondary"
                    floated='left'
                    icon='times'
                    content={t("close")}
                    onClick={closePartReview}
                />
            )}
        </T.RevisionFooter>
    );
};

export default WikiColumnReviewFooter;
